<template>
	<div class="mainContentBackground villageBackground unselectable">
		<div class="sea viewBackground" :style="{top: '0px', left: villageBackgroundLeft, right: 'auto', height: '1440px', transform: 'perspective(1000px) scale3d(1, 1, 1)', transformOrigin: '50% 50%', filter: 'blur(0px)', perspective: '1000px'}">
			<div class="modalWrapper reports" style="opacity: 1; top: 400px; align-items: flex-start; justify-content: center; display: flex; width: 100%; height: 100%;">
				<div class="modal reports">
					<div class="modalContent">
						<div class="modalDecoration"></div>
						<div class="functionPanel unselectable">
							<a class="closeWindow clickable" @click="$router.push('/township')">
								<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
									<i class="action_cancel_tiny_flat_black"></i>
								</div>
							</a>
						</div>
						<div>
							<div class="reportSearch">
								<span class="tabulation maintab">
									<a class="tab" :class="{active: tab == 'search', inactive: tab != 'search'}" @click="showSearch = !showSearch">
										<div class="content">
											<i class="action_search_small_flat_white" v-if="tab == 'search'"></i>
											<i class="action_search_small_flat_black" v-else></i>
										</div>
									</a>
								</span>
								<div class="searchWrapper" v-if="showSearch">
									<span class="serverautocompleteContainer ng-valid" autocompletedata="player,village,coords" autocompletecb="w.searchReports" ng-model="w.searchInputOverride" input-autofocus="true">
										<!-- ngIf: showOwnVillages -->
										<span role="status" aria-live="polite" class="ui-helper-hidden-accessible"></span>
										<input ng-disabled="disabledInput" class="targetInput ng-pristine ng-valid ui-autocomplete-input ng-touched" type="text" ng-model="modelInput" ng-focus="onFocus();hideOwnVillagesList();" autocomplete="off" placeholder="Поиск..." @keyup.enter="tab = 'search'" />
										<label ng-class="{ownVillagesShown: showOwnVillages}" style="width: 226px;">
											<i class="action_search_tiny_flat_white"></i>
											Игрок, Деревня, Координаты
										</label>
										<!-- ngIf: showOwnVillages -->
										<!--
										игроки
										<ul class="ui-autocomplete ui-front ui-menu ui-widget ui-widget-content ui-corner-all serverautocomplete dropdownBody" id="ui-id-2" tabindex="0" style="display: none; top: 235px; left: 884px; width: 248px;"><li class="autocomplete ui-menu-item" role="presentation"><a id="ui-id-13" class="ui-corner-all" tabindex="-1"><div class="resultRow"><span class="resultName">lexinzector</span><span class="resultType">(Игрок)</span></div></a></li></ul>
										
										координаты
										<ul class="ui-autocomplete ui-front ui-menu ui-widget ui-widget-content ui-corner-all serverautocomplete dropdownBody" id="ui-id-2" tabindex="0" style="display: none; top: 235px; left: 884px; width: 248px;"><li class="autocomplete ui-menu-item" role="presentation"><a id="ui-id-39" class="ui-corner-all" tabindex="-1"><div class="resultRow"><span class="resultName">Оазис (-14|-32)</span><span class="resultType"></span></div></a></li><li class="autocomplete ui-menu-item" role="presentation"><a id="ui-id-40" class="ui-corner-all" tabindex="-1"><div class="resultRow"><span class="resultName">Оазис (-14|-22)</span><span class="resultType"></span></div></a></li><li class="autocomplete ui-menu-item" role="presentation"><a id="ui-id-41" class="ui-corner-all" tabindex="-1"><div class="resultRow"><span class="resultName">Оазис (-14|-14)</span><span class="resultType"></span></div></a></li><li class="autocomplete ui-menu-item" role="presentation"><a id="ui-id-42" class="ui-corner-all" tabindex="-1"><div class="resultRow"><span class="resultName">Оазис (-14|-10)</span><span class="resultType"></span></div></a></li><li class="autocomplete ui-menu-item" role="presentation"><a id="ui-id-43" class="ui-corner-all" tabindex="-1"><div class="resultRow"><span class="resultName">Оазис (-14|7)</span><span class="resultType"></span></div></a></li><li class="autocomplete ui-menu-item" role="presentation"><a id="ui-id-44" class="ui-corner-all" tabindex="-1"><div class="resultRow"><span class="resultName">Оазис (-14|19)</span><span class="resultType"></span></div></a></li><li class="autocomplete ui-menu-item" role="presentation"><a id="ui-id-45" class="ui-corner-all" tabindex="-1"><div class="resultRow"><span class="resultName">Оазис (-14|22)</span><span class="resultType"></span></div></a></li><li class="autocomplete ui-menu-item" role="presentation"><a id="ui-id-46" class="ui-corner-all" tabindex="-1"><div class="resultRow"><span class="resultName">Оазис (-14|40)</span><span class="resultType"></span></div></a></li><li class="autocomplete ui-menu-item" role="presentation"><a id="ui-id-47" class="ui-corner-all" tabindex="-1"><div class="resultRow"><span class="resultName">Оазис (-14|58)</span><span class="resultType"></span></div></a></li></ul>
										
										деревни
										<ul class="ui-autocomplete ui-front ui-menu ui-widget ui-widget-content ui-corner-all serverautocomplete dropdownBody" id="ui-id-2" tabindex="0" style="display: none; top: 235px; left: 884px; width: 248px;"><li class="autocomplete ui-menu-item" role="presentation"><a id="ui-id-48" class="ui-corner-all" tabindex="-1"><div class="resultRow"><span class="resultName">_01</span><span class="resultType">&#x202D;<span class="coordinateX">&#x202D;(&#x202C;&#x202D;-&#x202D;14&#x202C;&#x202C;</span><span class="coordinatePipe">|</span><span class="coordinateY">&#x202D;&#x202D;13&#x202C;&#x202C;&#x202D;)&#x202C;</span>&#x202C;</span></div></a></li><li class="autocomplete ui-menu-item" role="presentation"><a id="ui-id-49" class="ui-corner-all" tabindex="-1"><div class="resultRow"><span class="resultName">NaTR_01</span><span class="resultType">&#x202D;<span class="coordinateX">&#x202D;(&#x202C;&#x202D;-&#x202D;4&#x202C;&#x202C;</span><span class="coordinatePipe">|</span><span class="coordinateY">&#x202D;&#x202D;6&#x202C;&#x202C;&#x202D;)&#x202C;</span>&#x202C;</span></div></a></li><li class="autocomplete ui-menu-item" role="presentation"><a id="ui-id-50" class="ui-corner-all" tabindex="-1"><div class="resultRow"><span class="resultName">Хорошкино_01</span><span class="resultType">&#x202D;<span class="coordinateX">&#x202D;(&#x202C;&#x202D;&#x202D;43&#x202C;&#x202C;</span><span class="coordinatePipe">|</span><span class="coordinateY">&#x202D;&#x202D;30&#x202C;&#x202C;&#x202D;)&#x202C;</span>&#x202C;</span></div></a></li></ul>
										-->
									</span>
								</div>
							</div>
							<div class="contentHeader unselectable">
								<h2 class="msAntiScroll drag" draggable="true">
									<span class="building"><span>Отчеты</span></span>
								</h2>
							</div>
						</div>
						<div class="heightTransitionContent" :style="{maxHeight: maxHeightContent, height: (gameModel.reports.showReportInfo ? maxHeightContent : 'auto')}">
							<div class="contentTabulation">
								<nav class="tabulation  maintab unselectable">
									<a class="tab clickable" :class="{active: tab == 'own', inactive: tab != 'own'}" @click="onToggleTab('own')">
										<div class="content">
											<span>Свои</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'kingdom', inactive: tab != 'kingdom'}" @click="onToggleTab('kingdom')">
										<div class="content">
											<span>Королевство</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'secret-society', inactive: tab != 'secret-society'}" @click="onToggleTab('secret-society')">
										<div class="content">
											<span>Тайные сообщества</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'favorites', inactive: tab != 'favorites'}" @click="onToggleTab('favorites')">
										<div class="content">
											<span>Избранное</span>
										</div>
									</a>
								</nav>
								<div class="tabulationContent scrollable">
									<div class="scrollContentOuterWrapper">
										<div class="scrollContent" style="overflow-y: auto;" :style="{maxHeight: maxHeightInnerContent}">
											<div class="scrollContentInnerWrapper" style="width: auto;">
												<div class="loadedTab currentTab" v-if="tab == 'own'">
													<own />
												</div>
												<div class="loadedTab currentTab" v-if="tab == 'kingdom'">
													<kingdom />
												</div>
												<div class="loadedTab currentTab" v-if="tab == 'secret-society'">
													<secret-society />
												</div>
												<div class="loadedTab currentTab" v-if="tab == 'favorites'">
													<favorites />
												</div>
												<div class="loadedTab currentTab" v-if="tab == 'search'">
													<search />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="window-overlay">
							<report-info :max-height-content="maxHeightContentWindowOverlay" v-if="gameModel.reports.showReportInfo"></report-info>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.societyFilter {
	float: right;
}
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Own from '@/components/pages/reports/Own';
import Kingdom from '@/components/pages/reports/Kingdom';
import SecretSociety from '@/components/pages/reports/SecretSociety';
import Favorites from '@/components/pages/reports/Favorites';
import Search from '@/components/pages/reports/Search';

import ReportInfo from '@/components/pages/reports/windowOverlay/ReportInfo';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Отчеты | IW'});
	},
	data: () => ({
		maxHeightContent: '550px',
		maxHeightInnerContent: '530px',
		maxHeightContentWindowOverlay: '494px',
		cancelHover: false,
		
		tab: 'own',
		showSearch: false,
		
		villageBackgroundLeft: '0px',
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_20.ogg');
				audio.play();
			}
		},
		onModalClose(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_7.ogg');
				audio.play();
			}
		},
		onToggleTab(tab, push = true){
			this.tab = tab;
			if(push) this.$router.push({query: {tab}});
			
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_8.ogg');
				audio.play();
			}
		},
		
		onResize(){
			//let leftpos = (window.innerWidth / 2) - (1920 / 2) - 70;
			let leftpos = (window.innerWidth / 2) - (1920 / 2);
			//console.log(window.innerWidth, leftpos);
			this.villageBackgroundLeft = leftpos+'px';
			
			let maxHeightContent = window.innerHeight - 325;
			maxHeightContent = (maxHeightContent < 550 ? 550 : maxHeightContent);
			this.maxHeightContent = maxHeightContent + 'px';
			this.maxHeightContentWindowOverlay = (maxHeightContent - 56) + 'px';
			this.maxHeightInnerContent = (maxHeightContent - 57 > 0 ? maxHeightContent - 57 : 0) + 'px';
		},
	},
	mounted(){
		this.onModalOpen();
		
		window.addEventListener('resize', this.onResize);
		this.onResize();
		
		if(this.$route.query.tab) this.tab = this.$route.query.tab;
		else this.$router.push({query: {tab: this.tab}});
	},
	unmounted(){
		this.onModalClose();
		this.gameModel.reports.showReportInfo = false;
		this.gameModel.reports.selectedReport = null;
		
		window.removeEventListener('resize', this.onResize); 
	},
	beforeRouteUpdate(to, from, next){
		if(!to.query.tab) this.$router.push({query: {tab: 'own'}});
		else if(to.query.tab != this.tab) this.onToggleTab(to.query.tab, false);
		next();
	},
	created(){
		this.gameModel.buildingQueueShow = true;
	},
	components: {
		Own,
		Kingdom,
		SecretSociety,
		Favorites,
		Search,
		ReportInfo,
	},
}
</script>